/* src/app/app.component.scss */
.innerItem {
  width: 100%;
  --inner-padding-start: 0;
  --inner-padding-end: 0;
  --padding-start: 0;
  --padding-end: 0;
}
.menu-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.menu-content .menu-top {
  flex: 1 1 100%;
}
.menu-content .menu-bot {
  flex: 0 0 0%;
}
.item-divider {
  height: 0px;
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.13);
}
.header-row {
  width: 100%;
  display: flex;
  padding: 5px;
}
.header-row .start,
.header-row .end,
.header-row .center {
  display: flex;
  align-items: center;
  flex: 1 1 100%;
}
.header-row .start {
  justify-content: flex-start;
}
.header-row .end {
  justify-content: flex-end;
}
.header-row .center {
  justify-content: center;
  text-align: center;
}
.bottom-row {
  width: 100%;
  display: flex;
}
.bottom-row .section {
  flex: 1 1 100%;
  padding: 5px;
}
.bottom-row .section:nth-child(2) {
  text-align: center;
  font-weight: bold;
}
.bottom-row .section:nth-child(3) {
  text-align: right;
}
.italics {
  font-style: italic;
}
ion-label p.index-warning {
  color: var(--ion-color-warning);
}
/*# sourceMappingURL=app.component.css.map */
